<template>
  <div v-if="visible" 
       class="dire-toast-banner" 
       :class="{ 'show': show }"
       role="dialog"
       aria-labelledby="banner-title"
       aria-modal="false">
    <div class="banner-wrapper">
      <button class="banner-close-area" 
              @click="closeBanner" 
              title="Chiudi banner" 
              aria-label="Chiudi banner"
              type="button"></button>
      
      <div class="banner-image-container">
        <a href="https://www.registroimprese.it/l-anagrafe-nazionale-delle-imprese" 
           target="_blank" 
           rel="noopener noreferrer"
           :title="$t('msg.title-toast-banner')"
           id="banner-title">
          <!-- Utilizzo percorsi assoluti dalla cartella public -->
          <img src="/img/30anni_desktop.jpg" 
               :alt="$t('msg.alt-toast-banner')" 
               class="banner-img-desktop" />
          <img src="/img/30anni_mobile.jpg" 
               :alt="$t('msg.alt-toast-banner')" 
               class="banner-img-mobile" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ToastBanner',
  props: {
    startDate: { type: String, default: '2026-05-01' },
    endDate: { type: String, default: '2026-07-01' }
  },
  data() {
    return {
      visible: false,
      show: false
    };
  },
  mounted() {
    this.checkActivation();
    document.addEventListener('keydown', this.handleKeydown);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeydown);
  },
  methods: {
    checkActivation() {
      const now = new Date();
      const start = new Date(this.startDate);
      const end = new Date(this.endDate);
      if (now >= start && now <= end) {
        this.visible = true;
        setTimeout(() => { this.show = true; }, 500);
      }
    },
    closeBanner() {
      this.show = false;
      setTimeout(() => { this.visible = false; }, 300);
    },
    handleKeydown(e) {
      if (this.visible && e.key === 'Escape') {
        this.closeBanner();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.dire-toast-banner {
  position: fixed;
  top: 35%;
  right: 0px;
  z-index: 1050;
  width: 350px;
  height: 173px;
  opacity: 0;
  transform: translateY(20px);
  transition: all 0.3s ease-in-out;
  pointer-events: none;

  &.show {
    opacity: 1;
    transform: translateY(0);
    pointer-events: auto;
  }
}

.banner-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  box-shadow: 0 5px 25px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  overflow: hidden;
  background-color: #fff; /* Ripristinato bianco per stabilità */
}

.banner-image-container {
  width: 100%;
  height: 100%;
  
  a {
    display: block;
    width: 100%;
    height: 100%;
    
    &:focus {
      outline: 2px solid #006F95;
    }
  }

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}

.banner-img-desktop {
  display: block;
}
.banner-img-mobile {
  display: none;
}

.banner-close-area {
  position: absolute;
  top: 0;
  right: 0;
  width: 40px;
  height: 40px;
  cursor: pointer;
  z-index: 10;
  background: transparent;
  border: none;
  padding: 0;
}

@media (max-width: 576px) {
  .dire-toast-banner {
    width: 300px;
    height: 250px;
    top: auto;
    bottom: 20px;
    right: 20px;
  }

  .banner-img-desktop {
    display: none !important;
  }
  .banner-img-mobile {
    display: block !important;
  }
}
</style>
